import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
const PLAYLIST_PATH = '/saved-items/playlists';
import UsageTracker from '../../../../utils/UsageTracker';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
export const PlaylistLink = ({
  playlistId,
  playlistName,
  position,
  portalId,
  truncate = true
}) => {
  const portalIdToUse = portalId !== null && portalId !== void 0 ? portalId : PortalIdParser.get();
  const href = `${PLAYLIST_PATH}/${playlistId}${portalIdToUse ? `/assignments/${portalIdToUse}` : ''}`;
  const handleClick = () => {
    UsageTracker.track('teamInteraction', {
      action: 'playlist-link-clicked',
      playlistId: playlistId.toString(),
      title: playlistName,
      to: href,
      position: position !== null && position !== void 0 ? position : undefined
    });
  };
  return /*#__PURE__*/_jsx(RouterLink, {
    onClick: handleClick,
    to: href,
    children: truncate ? /*#__PURE__*/_jsx(TruncateString, {
      children: playlistName
    }) : playlistName
  });
};
export default PlaylistLink;